/* eslint-disable import/max-dependencies -- Central lazy-import registry for all app flows */
import React from 'react'

/*============================================
 * v1 Flows - Old flows
 *============================================*/

export const EnrollVirtualCard = React.lazy(
  () => import('./screens/enrollment/virtual') /* webpackChunkName: "EnrollmentVirtual" */,
)

export const CancelCard = React.lazy(
  () => import('./screens/cancel-card' /* webpackChunkName: "CancelCard" */),
)

export const CancelCardProduct = React.lazy(
  () => import('./screens/cancel-card' /* webpackChunkName: "CancelCardProduct" */),
)

export const ChangePin = React.lazy(
  () => import('./screens/change-pin' /* webpackChunkName: "ChangePin" */),
)

export const Summary = React.lazy(
  () => import('./screens/summary' /* webpackChunkName: "Summary" */),
)

export const ViewPin = React.lazy(
  () => import('./screens/view-pin' /* webpackChunkName: "ViewPin" */),
)

export const Funding = React.lazy(
  () => import('./screens/funding' /* webpackChunkName: "Funding" */),
)

export const FundingProduct = React.lazy(
  () => import('./screens/funding' /* webpackChunkName: "FundingProduct" */),
)

export const ChangeCvv = React.lazy(
  () => import('./screens/change-cvv' /* webpackChunkName: "ChangeCvv" */),
)

export const NotFound = React.lazy(
  () => import('./screens/common/NotFound' /* webpackChunkName: "NotFound" */),
)

export const ProductEligibilityResult = React.lazy(
  () =>
    import(
      './screens/product-eligibility-result' /* webpackChunkName: "ProductEligibilityResult" */
    ),
)

/*============================================
 * v2 Flows - New flows with Redux toolkit
 *============================================*/

export const EnrollCardFlow = React.lazy(
  () => import('./screens/enroll-card/EnrollCardFlow') /* webpackChunkName: "EnrollCard" */,
)

export const ActivateCardFlow = React.lazy(
  () => import('./screens/activate-card/ActivateCardRoute' /* webpackChunkName: "ActivateCard" */),
)

export const ChangeAddressFlow = React.lazy(
  () =>
    import('./screens/change-address/ChangeAddressRouter' /* webpackChunkName: "ChangeAddress" */),
)

export const ConfirmCardAddressFlow = React.lazy(
  () =>
    import(
      './screens/confirm-card-address/ConfirmCardAddressFlow' /* webpackChunkName: "ConfirmCardAddress" */
    ),
)

export const AddAddressFlow = React.lazy(
  () => import('./screens/change-address/AddAddressRouter' /* webpackChunkName: "AddAddress" */),
)

export const ReplaceCardFlow = React.lazy(
  () => import('./screens/replace-card/ReplaceCardFlow' /* webpackChunkName: "ReplaceCard" */),
)

export const SetPinFlow = React.lazy(
  () => import('./screens/set-pin/SetPinFlow') /* webpackChunkName: "SetPin" */,
)

export const ShowCardFlow = React.lazy(
  () => import('./screens/show-card/ShowCardFlow') /* webpackChunkName: "ShowCard" */,
)

export const LowBalanceAlertSettingsFlow = React.lazy(
  () => import('./screens/low-balance-alert' /* webpackChunkName: "LowBalanceAlert" */),
)

export const StaticPageFlow = React.lazy(
  () => import('./screens/static-page/StaticPageFlow') /* webpackChunkName: "StaticPage" */,
)

export const RequestPhysicalCardFlow = React.lazy(
  () =>
    import(
      './screens/request-physical-card/RequestPhysicalCardFlow'
    ) /* webpackChunkName: "RequestPhysicalCard" */,
)

export const XoPpdcFlow = React.lazy(() => {
  return import('./screens/xo-ppdc-upsell/xo-ppdc') /* webpackChunkName: "XoPpdcFlow" */
})

export const SetupFI = React.lazy(
  () =>
    import(
      './screens/funding-instrument/SetupFundingInstrumentFlow'
    ) /* webpackChunkName: "SetupFundingInstrumentPage" */,
)

/*============================================
 * Main page layout
 *============================================*/
export const ManageCard = React.lazy(
  () => import('./screens/manage-card') /* webpackChunkName: "ManageCard" */,
)

export const BdmcSummary = React.lazy(
  () => import('./screens/bdmc-summary/BdmcSummary') /* webpackChunkName: "BdmcSummary" */,
)

export const BdmcRewards = React.lazy(
  () => import('./screens/bdmc/rewards-dashboard') /* webpackChunkName: "BdmcRewards" */,
)

export const BdmcEnrollFlow = React.lazy(
  () => import('./screens/bdmc-enroll/BdmcEnrollFlow') /* webpackChunkName: "BdmcEnroll" */,
)

export const BdmcRecurringPayments = React.lazy(
  () =>
    import(
      './screens/bdmc-recurring-payments/BdmcRecurringPayments' /* webpackChunkName: "BdmcRecurringPayments" */
    ),
)

export const BdmcFaqPage = React.lazy(
  () => import('./screens/bdmc-faq/BdmcFaqPage') /* webpackChunkName: "BdmcFaqPage" */,
)

export const BdmcOptOutPage = React.lazy(
  () => import('./screens/bdmc-optout/BdmcOptOutPage') /* webpackChunkName: "BdmcOptOutPage" */,
)

export const PpccLandingPage = React.lazy(
  () => import('./screens/ppcc-landing-page') /* webpackChunkName: "PpccLandingPage" */,
)

export const Rewards = React.lazy(
  () => import('./screens/rewards') /* webpackChunkName: "Rewards" */,
)

export const CardLimits = React.lazy(
  () => import('./screens/card-limits') /* webpackChunkName: "CardLimits" */,
)

export const LostCardPostStepupPage = React.lazy(
  () =>
    import(
      './screens/bdmc-report-lost-post-stepup/LostCardPostStepupPage' /* webpackChunkName: "LostCardPostStepup" */
    ),
)
